<template>
  <div class="register">
    <div class="content">
      <div class="label">{{ $t('phone') }}</div>
      <mt-field
        :placeholder="$t('phonePlaceholder')"
        v-model="form.phone"
        type="tel"
        v-mask="'#### #### #### #'"
        :state="phoneState"
      ></mt-field>
      <div class="label">{{ $t('idcard') }}</div>
      <mt-field
        :placeholder="$t('idcardPlaceholder')"
        v-mask="'#### #### ###'"
        :state="idcardState"
        v-model="form.idcard"
      ></mt-field>
      <div class="label">{{ $t('password') }}</div>
      <mt-field
        :placeholder="$t('passwordPlaceholder')"
        :type="!visible? 'password': 'text'"
        v-model="form.password"
        :state="passwordState"
      >
        <img v-if="!visible" class="visible" src="../../assets/notVisible.png" height="20px" @click="visible = true">
        <img v-else class="visible" src="../../assets/browse.png" height="20px" @click="visible = false">
      </mt-field>
      <div class="label">{{ $t('confirmPassword') }}</div>
      <mt-field
        :placeholder="$t('passwordPlaceholder')"
        :type="!newVisible? 'password': 'text'"
        v-model="form.comfirmPassword"
        :state="comfirmPasswordState"
      >
        <img v-if="!newVisible" class="visible" src="../../assets/notVisible.png" height="20px" @click="newVisible = true">
        <img v-else class="visible" src="../../assets/browse.png" height="20px" @click="newVisible = false">
      </mt-field>
      <template v-if="isValidateCode == 'Y'">
        <div class="label">{{ $t('validateCode') }}</div>
        <mt-field v-model="form.validateCode" :state="validateCodeState">
          <mt-button type="primary" size="small" plain :disabled="!!time" @click="getSmsCode('REGISTER')">{{
            $t("smsCode")
          }}{{ time? `(${time})`: '' }}</mt-button>
        </mt-field>
        <div class="smsCode">
          {{ $t("youCanTry") }}
          <mt-button size="small" @click="getIvrCode('REGISTER')" :disabled="!!time">{{ $t("getIvrCode") }}{{ time? `(${time})`: '' }}</mt-button>
        </div>
      </template>
    </div>
    <div class="bottom">
      <mt-button type="primary" size="large" @click="submit">{{
        $t("register")
      }}</mt-button>
      <div class="other">
        <div class="left" @click="onLogin">{{ $t('login') }}</div>
        <div class="right" @click="onPassword">{{ $t('forgetPassword') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { phoneRules, idcardRules, validateCodeRules, passwordRules, comfirmPasswordRules } from "../../utils/rules";
import { mapMutations } from "vuex";
import { registeredUser } from '../../utils/api'
import mixin from './mixin'
import branch from '../../../node_modules/branch-sdk'
import Vue from 'vue'
import gtmPageView from '../../utils/gtm.js'
export default {
  name: 'Register',
  mixins: [mixin],
  props: ['value'],
  data() {
    return {
      visible: false,
      newVisible: false,
    }
  },
  computed: {
    phoneState() {
      this.SET_RECORD_ITEM({
        key: "registerPhone",
        value: this.form.phone,
      });
      return this.isCheck ? phoneRules(this.form.phone) : null;
    },
    idcardState() {
      this.SET_RECORD_ITEM({
        key: "idcard",
        value: this.form.phone,
      });
      return this.isCheck ? idcardRules(this.form.idcard.replace(/\s/g, '')) : null;
    },
    validateCodeState() {
      return this.isCheck ? validateCodeRules(this.form.validateCode) : null;
    },
    passwordState() {
      this.SET_RECORD_ITEM({
        key: "registerPassword",
        value: this.form.password,
      });
      return this.isCheck ? passwordRules(this.form.password) : null;
    },
    comfirmPasswordState() {
      this.SET_RECORD_ITEM({
        key: "comfirmRegisterPassword",
        value: this.form.comfirmPassword,
      });
      return this.isCheck ? comfirmPasswordRules(this.form.comfirmPassword, this.form.password) : null;
    }
  },
  watch: {
    value() {
      this.form.phone = this.record.registerPhone || "";
      this.form.password = this.record.registerPassword || "";
      this.form.password = this.record.comfirmRegisterPassword || "";
    },
    'brand.isValidateCode': {
      handler(val) {
        this.isValidateCode = val || 'Y'
      },
      immediate: true
    },
    isValidateCode(val) {
      if (val == 'N') {
        this.submit()
      }
    }
  },
  created() {
    gtmPageView(this)
  },
  methods: {
    ...mapMutations(["SET_RECORD_ITEM", "SET_ACCESS_TOKEN"]),
    onPassword() {
      this.SET_RECORD_ITEM({
        key: "passwordPhone",
        value: this.form.phone,
      });
      this.$emit('input', 'password')
    },
    onLogin() {
      this.SET_RECORD_ITEM({
        key: "loginPhone",
        value: this.form.phone,
      });
      this.$emit('input', 'login')
    },
    async submit() {
      this.isCheck = true;
      var error;
      if (this.isValidateCode == 'Y') {
        error = this.validation(['phone', 'idcard', 'validateCode', 'password', 'comfirmPassword']);
      } else {
        error = this.validation(['phone', 'idcard', 'password', 'comfirmPassword']);
      }
      if (error) return this.$toast(error);
      this.$indicator.open({
        spinnerType: "fading-circle",
      });
      try {
        // 自定义事件
        let pixel = window.Vue.$route.query['pixel'] || localStorage['pixel']
        if (pixel) {
          Vue.analytics.fbq.event('06_REGISTER', { content_name: '06_REGISTER' })
        }
        // Google Analytics  REGISTER
        if (localStorage['ga']) {
          window.gtag('event', 'REGISTER')
        }
      } catch(e) {
        console.log(e)
      }
      let data = {
        phone: this.form.phone.replace(/\s/g, ""),
        idcard: this.form.idcard.replace(/\s/g, ""),
        password: this.form.password,
        comfirmPassword: this.form.comfirmPassword,
        validateCode: this.form.validateCode,
        isValidateCode: this.isValidateCode
      }
      await this.$axios({
        method: "post",
        url: registeredUser,
        data: data,
      })
        .then(async (e) => {
          if (e.status.code == "000") {
            this.SET_ACCESS_TOKEN(e.body.accessToken);
            this.SET_RECORD_ITEM({
              key: "loginPhone",
              value: this.form.phone,
            });
            this.SET_RECORD_ITEM({
              key: "loginPassword",
              value: this.form.password,
            });
            await this.getUser();
          } else if (e.status.code === '986') {
            this.SET_RECORD_ITEM({
              key: "loginPhone",
              value: this.form.phone,
            });
            this.$emit('input', 'login')
            this.$toast(e.status.msg)
          } else {
            this.$toast(e.status.msg)
          }
        })
        .catch(() => {});
      this.$indicator.close();
      branch.logEvent('06_REGISTER', { metadata: data })
    },
  }
}
</script>

<style lang="scss" scoped>
.register {
  margin-left: 30px;
  margin-right: 30px;
  .ivr_box {
    padding: 10px 0;
  }
  .visible {
    margin-left: 5px;
  }
  .label {
    font-size: 12px;
    color: #1C252A;
    margin-left: 10px;
    margin-bottom: 10px;
    margin-top: 25px;
  }
  .mint-field {
    min-height: 35px;
    background-image: initial;
    border-radius: 6px;
    /deep/ .mint-cell-wrapper {
      background-image: initial;
    }
  }
  .smsCode {
    text-align: center;
    margin-top: 10px;
  }
  .bottom {
    padding-top: 25px;
    .mint-button {
      &:last-child {
        margin-top: 10px;
      }
    }
  }
  .other {
    color: #47B526;
    font-size: 14px;
    margin: 20px;
    .left {
      display: inline-block;
    }
    .right {
      float: right;
    }
  }
}
</style>